"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useCardDetailsConsent = void 0;
var _auth = require("@ori/auth");
var _checkoutUtils = require("@ori/checkout-utils");
var _environment = require("@ori/environment");
var _fetching = require("@ori/fetching");
var _i18n = require("@ori/i18n");
var _react = require("react");
var _constants = require("../constants");
var _constantsGenerated = require("../constants-generated");
var _logger = require("../logger");
const useCardDetailsConsent = (isCardDetailsConsent)=>{
    const [isUserConsent, setIsUserConsent] = (0, _react.useState)(isCardDetailsConsent);
    let isSwrActive = false;
    const consentData = {
        isSaved: !isUserConsent
    };
    const { tenant } = (0, _environment.useEnvironment)();
    const { language } = (0, _i18n.useLanguage)();
    const { formattedToken } = (0, _auth.useToken)();
    const baseOptions = {
        applicationName: _constantsGenerated.APP_NAME,
        basePath: '/system/ajax/PaymentSelection/UpdateCardDetailsConsent',
        currentLanguage: language,
        formattedToken,
        tenant
    };
    const { cacheKeys, urlOptions } = (0, _checkoutUtils.getUrlOptions)(baseOptions);
    const fetchData = async (options)=>{
        const promise = (0, _checkoutUtils.getUrl)({
            ...options,
            method: _checkoutUtils.HttpMethod.Put,
            data: consentData
        });
        void promise.then((data)=>{
            isSwrActive = false;
            setIsUserConsent(data !== null && data !== void 0 ? data : false);
            (0, _logger.logDebug)('Consent update result', data);
            if (!(0, _checkoutUtils.isSSR)()) {
                window.dispatchEvent(new CustomEvent(_constants.CARD_CONSENT_UPDATED_EVENT));
            }
        });
        promise.catch((error)=>{
            _logger.mainLogger.error(error, {
                action: 'Consent update failed'
            });
        });
        return promise;
    };
    const fetcher = async ()=>fetchData(urlOptions);
    const { mutate } = (0, _fetching.useSWR)(// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always falsy
    isSwrActive ? cacheKeys : null, fetcher, _checkoutUtils.errorHandlingSwrOptions);
    function toggleUserConsent() {
        isSwrActive = true;
        void mutate(fetcher(), {
            optimisticData: !isUserConsent,
            rollbackOnError: true,
            populateCache: true,
            revalidate: false
        });
    }
    return {
        isUserConsent,
        toggleUserConsent
    };
};
exports.useCardDetailsConsent = useCardDetailsConsent;
